import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { translate } from "react-i18next"

const ResetButtonText = styled.span`
  padding-left: 5px !important;
  display: none;
`

const ResetButton = styled.button`
  float: right;
  line-height: 14px !important;
  border: 0 !important;
  &:hover ${ResetButtonText} {
    display: inline;
  }
`

function ResetAllFiltersButton({ t, onClick }) {
  return (
    <ResetButton className="btn btn-sm btn-secondary btn-rounded">
      <i className="fa fa-undo" />
      <ResetButtonText onClick={onClick}>{t("Filters.ResetAll")}</ResetButtonText>
    </ResetButton>
  )
}

ResetAllFiltersButton.propTypes = {
  t: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default translate()(ResetAllFiltersButton)



// WEBPACK FOOTER //
// ./src/components/filters/ResetAllFiltersButton.jsx